<template>
<DropdownModal
  :active.sync="activeAccessor"
  :overlay="false"
  :offset="[0, 8]"
  :arrow="false"
  placement="bottom-start"
>
  <template #toggle>
    <button
      type="button"
      class="focus:text-primary flex items-center p-2"
      style="font-weight: inherit;"
    >
      <slot name="toggle"></slot>
      <i
        class="fa fa-chevron-down ml-2 text-xs"
        style="font-weight: inherit; transition: transform 0.15s;"
        :style="{ 'transform': active ? 'rotate(180deg)' : undefined }"
      />
    </button>
  </template>
  <template #content>
    <ul
      style="max-height: calc(100vh - 8rem);"
      class="w-48 sm:w-auto overflow-auto"
    >
      <HeaderCategoriesDropdownCategory
        v-for="child of childCategories"
        :key="child.id"
        :category="child"
      />
    </ul>
  </template>
</DropdownModal>
</template>

<script>
import { mapPropsToAccessors } from '@/helpers/mapPropsToAccessors';

export default {
  components: {
    DropdownModal: () => import(/* webpackPreload: true */ '@/components/modals/DropdownModal'),
    HeaderCategoriesDropdownCategory: () => import(/* webpackPreload: true */ './HeaderCategoriesDropdownCategory'),
  },
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    childCategories: {
      type: Array,
      required: true,
      validator: v => v.length > 0,
    },
  },
  computed: {
    ...mapPropsToAccessors(['active'])
  }
}
</script>
